import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=1a16d0ad&scoped=true&"
import script from "./TextLink.vue?vue&type=script&lang=js&"
export * from "./TextLink.vue?vue&type=script&lang=js&"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=1a16d0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16d0ad",
  null
  
)

export default component.exports